import moment, { Moment } from 'moment';

export interface BattlePlayerStatusDTO {
	inactive_until: string;
	deactivated_indefinitely: boolean;
}

export enum BattlePlayerStatusType {
	AVAILABLE = 'available',
	TEMPORARY_NOT_AVAILABLE = 'temporary_not_available',
	NOT_AVAILABLE = 'not_available',
}

export enum BattlePlayerStatusOption {
	AVAILABLE = 'available',
	INACTIVE_FOR_24H = 'inactive_for_24h',
	INACTIVE_FOR_7D = 'inactive_for_7d',
	NOT_AVAILABLE = 'not_available',
}

export default class BattlePlayerStatus {
	public inactiveUntil: Moment | null;
	public deactivatedIndefinitely: boolean;

	constructor(battlePlayerStatus: BattlePlayerStatusDTO) {
		this.inactiveUntil = !!battlePlayerStatus.inactive_until ? moment(battlePlayerStatus.inactive_until) : null;
		this.deactivatedIndefinitely = battlePlayerStatus.deactivated_indefinitely;
	}

	get currentStatus(): BattlePlayerStatusType {
		if (this.deactivatedIndefinitely) {
			return BattlePlayerStatusType.NOT_AVAILABLE;
		}

		if (moment.isMoment(this.inactiveUntil) && this.inactiveUntil.isAfter()) {
			return BattlePlayerStatusType.TEMPORARY_NOT_AVAILABLE;
		}

		return BattlePlayerStatusType.AVAILABLE;
	}
}
